/* eslint-disable */
// 所有引入的第三方插件
import Vue from 'vue'
import VueLazyload from 'vue-lazyload'
import Vmodal from 'vue-js-modal' // https://github.com/euvl/vue-js-modal
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import VideoPlayer from 'vue-video-player' 
 

Vue.filter('time_sort', function (value, formatString) {
  var now_time = new Date().getTime() / 1000;
  var c_time = new Date(value).getTime() / 1000;
  c_time -= now_time;
  if (c_time <= 0) {
    return '已结束!'
  } else {
    var dd, hh, mm, ss = null;
    dd = Math.floor(c_time / 60 / 60 / 24);
    hh = Math.floor((c_time / 60 / 60) % 24);
    mm = Math.floor((c_time / 60) % 60);
    ss = Math.floor((c_time) % 60);
    dd = dd < 10 ? '0' + dd : dd;
    hh = hh < 10 ? '0' + hh : hh;
    mm = mm < 10 ? '0' + mm : mm;
    ss = ss < 10 ? '0' + ss : ss;
    return dd + "天" + hh + "小时" + mm + "分" + ss + "秒";
  }
})

Vue.use(VueLazyload, {
  preLoad: 1.3, // 预加载
  error: 'dist/error.png',  // 图片显示错误图片
  loading: 'dist/loading.gif', // 图片loading图片
  attempt: 1 // 重新加载次数
})
Vue.use(VueAwesomeSwiper)
Vue.use(Vmodal, { dynamic: true }) // 支持动态创建modal 动态创建的时候 一定要在当前组件下面引入此标签 <modals-container />  

// 添加时间过滤器 引入moment.js
Vue.filter('moment', function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(dataStr).format(pattern);
});